import storeRef from '@/store/instance';
import { analyticsService, technicianUtils } from '@puls/puls-general-utils';
import { STATE_MODULES } from '@/store/state-modules';
import { LoginGetters } from '@/store/modules/login/getters';
import ROUTES from '@/constants/routes';
import { LoginActions } from '@/store/modules/login/actions';
import { RouteLocationNormalized } from 'vue-router';

export const loginGuard = (to: RouteLocationNormalized) => {
	const jwt = storeRef.instance.state.login.userJWT;
	if (!jwt) return `${ROUTES.LOGIN}?return_url=${encodeURIComponent(to.fullPath)}`;
	storeRef.instance.dispatch(`${STATE_MODULES.LOGIN}/${LoginActions.INIT_USER}`)

	return true;
}

export const serviceProvideGuard = () => {
	const { service_provider_id } = storeRef.instance.state.technician;
	if (!!service_provider_id && technicianUtils.isLeadPartner(service_provider_id)) {
		return true
	} else {
		return ROUTES.JOBS;
	}
}

export const communicationGuard = () => {
	const validCommunication = storeRef.instance.getters[`${STATE_MODULES.LOGIN}/${LoginGetters.HAS_VALID_COMMUNICATION_METHOD}`];
	return validCommunication || ROUTES.LOGIN;
}

export const logRouteChange = (to: RouteLocationNormalized) => {
	analyticsService.pushVirtualPage(to.path)
}
